import React from 'react';
import { Box } from '@mui/material';
import styleVariables from 'src/scss/_variables.scss';
import {
  STAR_BORDER_DEFAULT_SPEED,
  STAR_BORDER_DEFAULT_THICKNESS,
  STAR_BORDER_ANIMATION_BOTTOM,
  STAR_BORDER_ANIMATION_TOP,
} from 'src/constants/starBorder';
import { StarBorderProps } from 'src/types/starBorder';

const StarBorder = <T extends React.ElementType = 'div'>({
  as,
  className = '',
  starColor = styleVariables.colorWhite,
  speed = STAR_BORDER_DEFAULT_SPEED,
  thickness = STAR_BORDER_DEFAULT_THICKNESS,
  children,
  ...rest
}: StarBorderProps<T>) => {
  const Component = as || 'div';
  const componentProps = rest as React.ComponentPropsWithoutRef<T>; // TODO: refine typing

  return (
    <Box
      component={Component}
      {...componentProps}
      className={className}
      sx={{
        position: 'relative',
        display: 'inline-block',
        overflow: 'hidden',
        borderRadius: '4px',
        padding: `${thickness}px 0`,
        ...(componentProps as any).sx,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: '300%',
          height: '50%',
          opacity: 0.7,
          bottom: '-11px',
          right: '-250%',
          background: `radial-gradient(circle, ${starColor}, transparent 10%)`,
          animation: `${STAR_BORDER_ANIMATION_BOTTOM} ${speed} linear infinite alternate`,
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: '300%',
          height: '50%',
          opacity: 0.7,
          top: '-10px',
          left: '-250%',
          background: `radial-gradient(circle, ${starColor}, transparent 10%)`,
          animation: `${STAR_BORDER_ANIMATION_TOP} ${speed} linear infinite alternate`,
          zIndex: 0,
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 1 }}>{children}</Box>
    </Box>
  );
};

export default StarBorder;
